export default {
      id: "INR-usage",
      viewBox: "0 0 332.7 512",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#INR",
      toString: function () {
        return this.url;
      }
    }